import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';
import React from 'react';

const CreditFacilityMissing = () => (
  <Alert
    status="error"
    variant="subtle"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    height="200px"
    maxWidth="900px"
    margin="30px auto"
  >
    <AlertIcon boxSize="40px" mr={0} />
    <AlertTitle mt={4} mb={1} fontSize="lg">
      Error
    </AlertTitle>
    <AlertDescription maxWidth="lg">
      There was an error retrieving your credit agreement. Please refresh the
      page. If you&apos;re still unable to connect, please contact Finley
      Support for more assistance.
    </AlertDescription>
  </Alert>
);

export default CreditFacilityMissing;
